const sidenav = {
  register: 'Register',
  overview: 'Overview',
  transactions: 'Transactions',
  customers: 'Customers',
  totalCustomers: 'customers/total_customers',
  vault: 'Redemption Vault',
  promo: 'Promo',
  campaignlink: 'promo/campaign',
  pos: 'POS',
  credit: 'Credits',
  review: 'Reviews',
  settlements: 'Settlements',
  settings: 'Settings',
  campaign: 'Campaign',
  games: 'Games',
};

export default sidenav;